import { TYPES } from 'action-types/download-selections';

export interface DefaultState {
    selectedRowData: Array<{
        selectedPage: number;
        headerChecked: boolean;
        selectedRows: any[];
    }>;
}

export const defaultState: DefaultState = {
    selectedRowData: [],
};

export const reducer = (state = defaultState, action: any) => {
    switch (action.type) {
        case TYPES.SAVE_TABLE_SELECTIONS:
            // Assuming action.payload contains { selectedPage, selectedRows, headerChecked }
            const { selectedPage, selectedRows, headerChecked = false } = action.payload;

            // Check if an entry for selectedPage already exists
            const existingPageIndex = state.selectedRowData.findIndex(
                (item) => item.selectedPage === selectedPage
            );

            if (existingPageIndex !== -1) {
                // If page exists, update its selectedRows and headerChecked
                return {
                    ...state,
                    selectedRowData: state.selectedRowData.map((item, index) =>
                        index === existingPageIndex
                            ? { ...item, selectedRows, headerChecked }
                            : item
                    ),
                };
            } else {
                // If page doesn't exist, append new entry
                return {
                    ...state,
                    selectedRowData: [
                        ...state.selectedRowData,
                        { selectedPage, selectedRows, headerChecked },
                    ],
                };
            }

        case TYPES.UPDATE_TABLE_SELECTIONS:
            // Assuming action.payload contains { selectedPage, selectedRows, headerChecked }
            const { selectedPage: updatePage, selectedRows: updateRows, headerChecked: updateHeaderChecked = false } = action.payload;

            // Check if the page exists
            const pageIndex = state.selectedRowData.findIndex(
                (item) => item.selectedPage === updatePage
            );

            if (pageIndex !== -1) {
                // If page exists, update its selectedRows and headerChecked
                return {
                    ...state,
                    selectedRowData: state.selectedRowData.map((item, index) =>
                        index === pageIndex
                            ? { ...item, selectedRows: updateRows, headerChecked: updateHeaderChecked }
                            : item
                    ),
                };
            } else {
                // If page doesn't exist, append new entry
                return {
                    ...state,
                    selectedRowData: [
                        ...state.selectedRowData,
                        { selectedPage: updatePage, selectedRows: updateRows, headerChecked: updateHeaderChecked },
                    ],
                };
            }

        case TYPES.RESET_TABLE_SELECTIONS:
            return {
                ...state,
                selectedRowData: [],
            };

        default:
            return state;
    }
};